export default __webpack_public_path__ + "static/media/manual-mottette.d45483fb.png";